<template>
  <v-card class="mx-auto" min-height="50">
    <div class="my-2">
      <v-row dense>
        <v-col class="px-5" cols="10">
          <h3>Estatística - Requisições</h3>
        </v-col>
        <v-col cols="2">
          <v-btn @click="ativaCardEstatisticas" color="primary" fab small dark absolute right>
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-card v-if="cardEstatisticas" class="mx-auto" min-height="50">
      <v-container fluid>
        <v-row dense>
          <v-col cols="4">
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Reqs - Canal/Valor</h4>
                  <PieChart v-bind:estatisticas="estatisticaReqCanalStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="180" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Canal</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaReqCanalStore[2]" :key="item[0]">
                        <td class="caption">{{ item.canalCaptacao }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro}}</td>
                        <td class="text-right caption">{{ item.valor | dinheiro}}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row dense>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Reqs - Loja/Qtde</h4>
                  <PieChart v-bind:estatisticas="estatisticaReqLojaStore[0]" />
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Reqs - Loja/Valor</h4>
                  <PieChart v-bind:estatisticas="estatisticaReqLojaStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="180" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Loja</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaReqLojaStore[2]" :key="item[0]">
                        <td class="caption">{{ item.cdfil }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro }}</td>
                        <td class="text-right caption">{{ item.venda | dinheiro }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row dense>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Reqs - Cliente/Qtde</h4>
                  <PieChart v-bind:estatisticas="estatisticaReqTipoClienteStore[0]" />
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Reqs - Cliente/Valor</h4>
                  <PieChart v-bind:estatisticas="estatisticaReqTipoClienteStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="180" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Tipo</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaReqTipoClienteStore[2]" :key="item[0]">
                        <td class="caption">{{ item.tipoCliente }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro }}</td>
                        <td class="text-right caption">{{ item.valor | dinheiro }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
import PieChart from "../components/charts/PieChart";
import { mapGetters } from "vuex";

export default {
  components: {
    PieChart
  },
  data: () => ({
    cardEstatisticas: false
  }),
  computed: {
    ...mapGetters({
      estatisticaReqCanalStore: "estatisticaRequisicoes",
      estatisticaReqLojaStore: "estatisticaRequisicoesPorLoja",
      estatisticaReqTipoClienteStore: "estatisticaRequisicoesPorTipoCliente"
    })
  },
  methods: {
    ativaCardEstatisticas() {
      if (this.cardEstatisticas === false) {
        this.cardEstatisticas = true;
      } else {
        this.cardEstatisticas = false;
      }
    }
  }
};
</script>

<style>
</style>